/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Proposal execution status */
export enum ProposalStatus {
  Draft,
  Active,
  Passed,
  Failed,
  Executed,
  Cancelled,
  Expired,
  Queued,
}

export type ProposalStatusArgs = ProposalStatus;

export function getProposalStatusEncoder(): FixedSizeEncoder<ProposalStatusArgs> {
  return getEnumEncoder(ProposalStatus);
}

export function getProposalStatusDecoder(): FixedSizeDecoder<ProposalStatus> {
  return getEnumDecoder(ProposalStatus);
}

export function getProposalStatusCodec(): FixedSizeCodec<
  ProposalStatusArgs,
  ProposalStatus
> {
  return combineCodec(getProposalStatusEncoder(), getProposalStatusDecoder());
}
